import { Controller} from "@hotwired/stimulus"
import $ from "jquery";

export default class AutoSubmitController extends Controller {
    static targets = ["form", "submit"]

    connect() {
        console.log('connected auto submit')
    }

    // as ckeditor-rails uses jquery_ujs we cannot use rails-ujs
    // hack: click hidden submit button (submitTarget)
    search(event) {
        const submit = this.submitTarget
        const target = event.currentTarget

        const value = target.value
        if (value.length > 1) {
            $(submit).click()
        }
    }

    submit() {
        console.log('submit')
        const submit = this.submitTarget
        $(submit).click()
    }
}